import { render, staticRenderFns } from "./config.vue?vue&type=template&id=60459a4e&scoped=true&"
import script from "./config.vue?vue&type=script&lang=ts&"
export * from "./config.vue?vue&type=script&lang=ts&"
import style0 from "./config.vue?vue&type=style&index=0&id=60459a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60459a4e",
  null
  
)

export default component.exports